import React, { useState } from "react";
import { X, ChevronDown } from "lucide-react";

const CancelOrderModal = ({
  showCancelModal,
  cancelReason,
  setCancelReason,
  setShowCancelModal,
  cancellationReasons,
  handleCancelConfirm,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  if (!showCancelModal) return null;

  return (
    <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/50 px-4">
      <div className="w-[95vw] max-w-md rounded-2xl bg-white p-4 sm:p-5 shadow-2xl">
        <div className="mb-4 flex items-center justify-between">
          <div>
            <h3 className="text-lg font-bold text-slate-900">Cancel Order</h3>
            <p className="mt-1 text-sm text-slate-500">
              Please select a cancellation reason.
            </p>
          </div>

          <button
            type="button"
            onClick={() => {
              setShowCancelModal(false);
              setCancelReason("");
            }}
            className="flex h-9 w-9 items-center justify-center rounded-full bg-slate-100 text-slate-600 hover:bg-slate-200"
          >
            <X size={18} />
          </button>
        </div>

        <div className="mb-5">
          <label className="mb-2 block text-sm font-semibold text-slate-700">
            Cancellation Reason
          </label>

         <div className="relative">
 <button
  type="button"
  onClick={() => setIsOpen(!isOpen)}
  className="flex w-full items-center justify-between rounded-lg border border-slate-300 bg-white px-3 py-3 text-left text-sm text-slate-700"
>
  <span>{cancelReason || "Select reason"}</span>

  <ChevronDown
    size={18}
    className={`transition-transform duration-200 ${
      isOpen ? "rotate-180" : ""
    }`}
  />
</button>

  {isOpen && (
    <div className="absolute left-0 right-0 top-full z-50 mt-1 rounded-lg border border-slate-300 bg-white shadow-lg">
      {cancellationReasons.map((reason) => (
        <button
          key={reason}
          type="button"
          onClick={() => {
            setCancelReason(reason);
            setIsOpen(false);
          }}
          className="block w-full px-3 py-2 text-left text-sm hover:bg-slate-100"
        >
          {reason}
        </button>
      ))}
    </div>
  )}
</div>
        </div>

        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
          <button
            type="button"
            onClick={() => {
              setShowCancelModal(false);
              setCancelReason("");
            }}
            className="rounded-lg border border-slate-200 bg-white py-3 font-bold text-slate-700 hover:bg-slate-50"
          >
            Keep Order
          </button>

          <button
            type="button"
            disabled={!cancelReason}
            onClick={handleCancelConfirm}
            className={`rounded-lg py-3 font-bold text-white transition ${
              cancelReason
                ? "bg-red-600 hover:bg-red-700"
                : "cursor-not-allowed bg-red-300"
            }`}
          >
            Confirm Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelOrderModal;